var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';
import { Formik } from 'formik';
import produce from 'immer';
import { get, uniqueId } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { validatePharmacyRequestExpiry } from '../../Async/PharmacyRequestsAsync';
import { searchEncounterPlaces } from '../../Async/PlacesAsync';
import { AlertBanner, AlertBannerTypes } from '../../Components/AlertBanner';
import { Button } from '../../Components/Button';
import { ImprovedDataTable } from '../../Components/DataTable/ImprovedDataTable';
import { FieldIconMode } from '../../Components/DatePicker';
import { FormikDatePicker } from '../../Components/FormikFields/FormikDatePicker';
import { FormikStyledSelectAsync } from '../../Components/FormikFields/FormikStyledSelectAsync';
import { FormikTextField } from '../../Components/FormikFields/FormikTextField';
import { FullScreenModal } from '../../Components/FullScreenModal';
import { AddIcon } from '../../Components/Icons';
import { LayoutCentral } from '../../Components/LayoutCentral';
import { MedicationCard, MedicationCardMode } from '../../Components/MedicationCard';
import { NoMedicationsFound } from '../../Components/NoMedicationsFound';
import { LoadingPlaceholder } from '../../Components/Placeholder';
import { StyledNavigationPrompt } from '../../Components/Prompts/StyledNavigationPrompt';
import { LoadingError } from '../../Components/SplashScreens/LoadingError';
import { displayError, displayMessage } from '../../Config/ApplicationConfig';
import { useMedicationSettings } from '../../Config/MedicationConfig';
import { MedicationExpiry, prettyPrintMedicationCourse, prettyPrintMedicationType } from '../../Contracts/MedicationModels';
import { MedicationLocale, oneMedicationMustBeSelected, requiredField } from '../../Medications.en';
import { calculateCourseInstructions } from '../../MedicationSummary/Utilities';
import { ValidDateFormats } from '../../Shared/DateUtilities';
import { debouncePromise } from '../../Shared/debouncePromise';
import { convertValidationResultToErrorsObjectV2, errorCodeLocalizer, getFirstErrorMessageFromApiError, isDomainValidationError } from '../../Shared/DomainValidationFunctions';
import { expiryStatusFromDate, isInactiveMedicationStatus } from '../../Shared/MedicationsHelpers';
import { lookupIdentifierToAuthSystemKey, lookupIdentifierToName } from '../../Shared/SharedModels';
import { MedicationExpiryType } from '../../Shared/Types';
import { primary } from '../../Styles/Colours';
import { FinalisingPharmacyRequest } from '../FinalisingPharmacyRequest';
import { PharmacyRequestResponseTypes } from '../PharmacyRequests';
import styles from './AddPharmacyRequestForm.module.css';
import { StyledDialog } from '../../Components/Dialog/StyledDialog';
import { ColorLinearProgress } from '../../Components/ColorLinearProgress';
import CreatingMedicationOrderGraphic from '../../Images/creatingMedicationOrder.svg';
var debouncedValidatePharmacyRequestExpiry = debouncePromise(validatePharmacyRequestExpiry, 250);
var columnExtensions = [
    {
        columnName: 'product'
    },
    {
        columnName: 'courseInstructions',
        width: 330
    },
    {
        columnName: 'type',
        width: 210
    },
    {
        columnName: 'courseExpiry',
        width: 145,
        align: 'right'
    }
];
var ROW_HEIGHT = 72;
var createPharmacyRequestSchema = yup.object({
    expiresOn: yup
        .string()
        .test('validate-pharmacy-request-expiry', '', function pharmacyRequestExpiry(date) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var requestItems, data, result, validationErrors_1, errors, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        requestItems = get(this.parent, 'requestItems');
                        if (!requestItems) return [3 /*break*/, 4];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        data = {
                            generatedOn: moment().format(ValidDateFormats.NodeDateTimeTimezone),
                            expiryDate: date ? moment(date).format(ValidDateFormats.IsoFormat) : null,
                            medicationsOnRequest: requestItems
                                .filter(function (x) { return x.selected; })
                                .map(function (x) {
                                return x.patientMedication;
                            })
                        };
                        return [4 /*yield*/, debouncedValidatePharmacyRequestExpiry(data)];
                    case 2:
                        result = _c.sent();
                        if (result === null || result === void 0 ? void 0 : result.success)
                            return [2 /*return*/, true];
                        validationErrors_1 = [];
                        (_a = result === null || result === void 0 ? void 0 : result.content) === null || _a === void 0 ? void 0 : _a.forEach(function (invalid) {
                            validationErrors_1.push(_this.createError({
                                message: errorCodeLocalizer(MedicationLocale, invalid),
                                path: 'expiresOn'
                            }));
                        });
                        errors = this.createError({});
                        errors.inner = validationErrors_1;
                        return [2 /*return*/, errors];
                    case 3:
                        _b = _c.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/, true];
                }
            });
        });
    }),
    pickupLocation: yup.object().nullable().required(requiredField),
    requestItems: yup.array(yup.object()).test({
        name: 'one-selected-medication',
        message: oneMedicationMustBeSelected,
        test: function (value) {
            return value.filter(function (it) { return it.selected; }).length >= 1;
        }
    })
});
var getColumns = function () {
    return [
        {
            name: 'product',
            title: 'Product',
            getCellValue: function (row) {
                var isSelected = row.selected;
                var strength = Number(row.patientMedication.strength);
                return (React.createElement(MedicationCard, { name: row.patientMedication.name, strength: isNaN(strength) ? 0 : strength, strengthUnit: row.patientMedication.strengthUnits, type: row.patientMedication.type, selected: isSelected, size: row.patientMedication.packAmount, productPackAmount: row.patientMedication.productPackAmount, repeatsAmount: row.patientMedication.repeatsAmount, mode: MedicationCardMode.Long, isNonStandardPackSize: row.patientMedication.isNonStandardPackSize, nonStandardPackSize: row.patientMedication.nonStandardPackSize }));
            }
        },
        {
            name: 'courseInstructions',
            title: 'Order instructions',
            getCellValue: function (row) {
                var instructions = calculateCourseInstructions({
                    orderInstructions: row.patientMedication.orderInstruction,
                    dosageInstructions: row.patientMedication.dosageInstruction,
                    type: row.patientMedication.type
                });
                return (React.createElement(Tooltip, { title: instructions, placement: 'bottom-start' },
                    React.createElement("div", { className: classNames(styles.rowMainText, styles.wrappingCell) }, instructions)));
            }
        },
        {
            name: 'type',
            title: 'Type',
            getCellValue: function (row) {
                return (React.createElement(MedicationTypeAndCourse, { course: row.patientMedication.course, type: row.patientMedication.type }));
            }
        },
        {
            name: 'courseExpiry',
            title: 'Expiry',
            getCellValue: function (row) {
                if (row.patientMedication.medicationExpiry === MedicationExpiryType.Fixed) {
                    return row.patientMedication.expiresOn
                        ? moment(row.patientMedication.expiresOn, ValidDateFormats.IsoFormat).format(ValidDateFormats.DisplaySlashSpace)
                        : '';
                }
                else {
                    return React.createElement("span", { className: styles.chartDuration }, "(Chart duration)");
                }
            }
        }
    ];
};
var MedicationTypeAndCourse = function (props) {
    return (React.createElement("div", null,
        React.createElement("div", null, prettyPrintMedicationType(props.type)),
        React.createElement("div", { className: styles.course }, prettyPrintMedicationCourse(props.course))));
};
function getErrorPharmacyRequestMessage(values, medicationSettings) {
    var _a, _b, _c, _d, _e, _f;
    return values.requestItems.length > 1
        ? "Unable to finalise " + ((_c = (_b = (_a = medicationSettings.settings.pharmacyRequestTerm) === null || _a === void 0 ? void 0 : _a.pluralTerm) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : 'pharmacy requests')
        : "Unable to finalise " + ((_f = (_e = (_d = medicationSettings.settings.pharmacyRequestTerm) === null || _d === void 0 ? void 0 : _d.singularTerm) === null || _e === void 0 ? void 0 : _e.toLowerCase()) !== null && _f !== void 0 ? _f : 'pharmacy request');
}
function getSuccessfulPharmacyRequestMessage(requestNumber, medicationSettings) {
    var _a, _b;
    return ((_b = (_a = medicationSettings.settings.pharmacyRequestTerm) === null || _a === void 0 ? void 0 : _a.singularTerm) !== null && _b !== void 0 ? _b : 'Request') + " #" + requestNumber + " created and sent to external pharmacy";
}
export var AddPharmacyRequestForm = function (props) {
    var medicationSettings = useMedicationSettings();
    var termName = medicationSettings.settings.pharmacyRequestTerm.singularTerm;
    var headlessUpdate = function (state) { return __awaiter(void 0, void 0, void 0, function () {
        var timeout, _a, results, message, e_1, errorMessage;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    timeout = new Promise(function (resolve) { return setTimeout(resolve, 2000); });
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all([props.onCreatePharmacyRequest(state), timeout])];
                case 2:
                    _a = __read.apply(void 0, [_e.sent(), 1]), results = _a[0];
                    message = getSuccessfulPharmacyRequestMessage(results, medicationSettings);
                    if ((_b = props.headlessUpdate) === null || _b === void 0 ? void 0 : _b.onSuccess) {
                        (_c = props.headlessUpdate) === null || _c === void 0 ? void 0 : _c.onSuccess({
                            type: PharmacyRequestResponseTypes.Success,
                            message: message
                        });
                    }
                    else {
                        displayMessage(message);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _e.sent();
                    console.error('Unable to create Pharmacy Request: ', e_1);
                    errorMessage = getErrorPharmacyRequestMessage(state, medicationSettings);
                    if ((_d = props.headlessUpdate) === null || _d === void 0 ? void 0 : _d.onFailure) {
                        props.headlessUpdate.onFailure({
                            type: PharmacyRequestResponseTypes.ServerError,
                            message: errorMessage,
                            errorPayload: e_1
                        });
                    }
                    else {
                        displayError(errorMessage);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var headlessUpdateFailure = function (message, errorPayload) {
        var _a;
        if ((_a = props.headlessUpdate) === null || _a === void 0 ? void 0 : _a.onFailure) {
            props.headlessUpdate.onFailure({
                type: PharmacyRequestResponseTypes.ValidationError,
                message: message,
                errorPayload: errorPayload
            });
        }
        else {
            displayError(message);
        }
    };
    return (React.createElement(Formik, { initialValues: {
            expiresOn: '',
            pickupLocation: null,
            requestItems: []
        }, validationSchema: createPharmacyRequestSchema, onSubmit: function (values, formikActions) { return __awaiter(void 0, void 0, void 0, function () {
            var requestNumber, err_1, errorMessage, errors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, props.onCreatePharmacyRequest(values)];
                    case 1:
                        requestNumber = _a.sent();
                        displayMessage(getSuccessfulPharmacyRequestMessage(requestNumber, medicationSettings));
                        formikActions.resetForm({ values: values });
                        props.onSuccess();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        errorMessage = getErrorPharmacyRequestMessage(values, medicationSettings);
                        displayError(errorMessage);
                        formikActions.setSubmitting(false);
                        if (isDomainValidationError(err_1)) {
                            if (err_1.content) {
                                errors = convertValidationResultToErrorsObjectV2(err_1.content, MedicationLocale, function (propertyName) {
                                    if (propertyName === 'ExpiryDate') {
                                        return 'expiresOn';
                                    }
                                    return propertyName;
                                });
                                formikActions.setErrors(errors.fieldErrors);
                            }
                        }
                        errorMessage = getFirstErrorMessageFromApiError(err_1, MedicationLocale);
                        displayError(errorMessage);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); } }, function (formikProps) {
        return (React.createElement(RenderForm, __assign({}, formikProps, { headlessUpdate: props.headlessUpdate && medicationSettings.settings.alwaysCreatePharmacyRequest
                ? {
                    update: headlessUpdate,
                    onValidationFailure: headlessUpdateFailure
                }
                : undefined, animationStyle: props.animationStyle, onClose: props.onClose, goToMedications: props.goToMedications, getMedicationsToRequest: props.getMedicationsToRequest })));
    }));
};
var toggleCell = function (_a) {
    var data = _a.data, expanded = _a.expanded, onToggle = _a.onToggle;
    if (expanded)
        return React.createElement("span", null);
    return (React.createElement("div", { onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            onToggle();
        }, className: styles.addNotesButton },
        React.createElement(AddIcon, { noPadding: true, size: '20', color: primary }),
        React.createElement("span", { className: styles.addNotes }, "Add Notes")));
};
var RenderForm = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var _s = __read(useState(true), 2), loading = _s[0], setLoading = _s[1];
    var _t = __read(useState(false), 2), hasLoadingError = _t[0], setHasLoadingError = _t[1];
    var medicationSettings = useMedicationSettings();
    var _u = __read(useState(''), 2), alertBannerTimespan = _u[0], setAlertBannerTimespan = _u[1];
    var buttons = !loading && props.values.requestItems.length > 0
        ? [
            React.createElement(Button, { key: 'confirm', width: 168, type: 'button', disabled: loading || !props.isValid || props.isSubmitting, testId: 'navigation-control-Confirm', onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    props.submitForm();
                } }, "Confirm")
        ]
        : [];
    var noResults = !loading && ((_a = props.values.requestItems.length === 0) !== null && _a !== void 0 ? _a : true);
    var expandedIds = props.values.requestItems.filter(function (it) { return it.showNotes && it.selected; }).map(function (it) { return it.id; });
    var expansionContent = React.useCallback(function (data) {
        var index = props.values.requestItems.findIndex(function (it) { return it.id === data.row.id; });
        return (React.createElement("div", { key: "request-item-expanded-" + data.row.id, className: styles.notesField },
            React.createElement(FormikTextField, { label: 'Additional notes', testId: "request-item-notes-" + index, name: "requestItems[" + index + "].notes", maxLength: 250 })));
    }, [props.values.requestItems.map(function (it) { return it.id; }).join('|')]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FetchMedicationToRequest, __assign({}, props, { getMedicationsToRequest: props.getMedicationsToRequest, onLoadStart: function () {
                setLoading(true);
            }, onLoadFinished: function () {
                setLoading(false);
            }, onError: function (message) {
                setLoading(false);
                setHasLoadingError(true);
                displayError(message);
            }, setAlertBannerTimespan: setAlertBannerTimespan })),
        React.createElement(StyledNavigationPrompt, { when: props.dirty || props.isSubmitting }),
        props.headlessUpdate && (React.createElement(React.Fragment, null, loading && (React.createElement(StyledDialog, { open: true, size: 'sm', modal: true, testId: 'pharmacy-request-loading-dialog', contentComponent: React.createElement(LayoutCentral, null,
                React.createElement("div", { className: styles.body },
                    React.createElement("img", { src: CreatingMedicationOrderGraphic, alt: '' }),
                    React.createElement("div", { className: styles.modalHeader },
                        "Creating a",
                        ' ',
                        React.createElement("span", { className: styles.modalHeaderEmphasis }, "new medication order")),
                    React.createElement("div", { className: styles.info }, "We're extending the chart expiry..."),
                    React.createElement(ColorLinearProgress, { className: styles.progress }))) })))),
        !props.headlessUpdate && (React.createElement(FullScreenModal, { title: loading || noResults
                ? ""
                : "Confirm the resident's " + ((_d = (_c = (_b = medicationSettings.settings.pharmacyRequestTerm) === null || _b === void 0 ? void 0 : _b.singularTerm) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : 'pharmacy request') + ".", info: loading || noResults
                ? ""
                : "The medications shown below will form the current " + ((_g = (_f = (_e = medicationSettings.settings.pharmacyRequestTerm) === null || _e === void 0 ? void 0 : _e.singularTerm) === null || _f === void 0 ? void 0 : _f.toLowerCase()) !== null && _g !== void 0 ? _g : 'pharmacy request') + " with the selected review/expiry date.", onClose: props.onClose, buttons: buttons, modalAnimationStyle: props.animationStyle, nonInteractivePlaceholder: props.isSubmitting ? (React.createElement(FinalisingPharmacyRequest, { pharmacyRequestTerm: medicationSettings.settings.pharmacyRequestTerm })) : null }, loading ? (React.createElement(LayoutCentral, null,
            React.createElement(LoadingPlaceholder, null))) : hasLoadingError ? (React.createElement(LayoutCentral, null,
            React.createElement(LoadingError, { message: 'Error loading medication data.' }))) : noResults ? (React.createElement(LayoutCentral, null,
            React.createElement(NoMedicationsFound, { largeMode: true, title: "No medication available to " + ((_k = (_j = (_h = medicationSettings.settings.pharmacyRequestTerm) === null || _h === void 0 ? void 0 : _h.abbreviatedSingularTerm) === null || _j === void 0 ? void 0 : _j.toLowerCase()) !== null && _k !== void 0 ? _k : 'request') + ".", info: 'Please add and finalise a new medication to your patient\u2019s record to continue.', onClickBack: props.goToMedications, useAlt: true, backLinkText: 'Visit medication' }))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.requestFields },
                React.createElement("div", { className: styles.encounterPlace },
                    React.createElement(FormikStyledSelectAsync, { testId: 'encounter-place', label: (_l = medicationSettings.settings.encounterPlaceTerm) === null || _l === void 0 ? void 0 : _l.singularTerm, required: true, name: 'pickupLocation', itemToString: lookupIdentifierToName, itemToMenuKey: lookupIdentifierToAuthSystemKey, fetch: searchEncounterPlaces, maxResults: 5, isClearable: true })),
                React.createElement("div", { className: styles.requestExpiry },
                    React.createElement(FormikDatePicker, { required: medicationSettings.settings.pharmacyRequestExpiryRequired, calendarIconMode: FieldIconMode.Embed, label: ((_o = (_m = medicationSettings.settings.pharmacyRequestTerm) === null || _m === void 0 ? void 0 : _m.abbreviatedSingularTerm) !== null && _o !== void 0 ? _o : 'request') + " expiry", name: 'expiresOn', testId: 'date-picker-request-expiry', fillContainer: true }))),
            !!alertBannerTimespan && (React.createElement("div", { className: styles.alertBanner },
                React.createElement(AlertBanner, { promptType: AlertBannerTypes.Error, promptMessage: "The " + ((_r = (_q = (_p = medicationSettings.settings.pharmacyRequestTerm) === null || _p === void 0 ? void 0 : _p.singularTerm) === null || _q === void 0 ? void 0 : _q.toLowerCase()) !== null && _r !== void 0 ? _r : 'pharmacy request') + " expiry date has been set to " + alertBannerTimespan + " from today.", promptExtraInfo: 'One or more medications were prescribed with a longer course expiry.', center: true, noBorder: true, roundIcon: true }))),
            React.createElement("div", { className: styles.tableContainer },
                React.createElement(ImprovedDataTable, { columns: getColumns(), rowHeight: ROW_HEIGHT, data: props.values.requestItems, getRowId: function (item) { return item.id; }, rowStyles: function (_a) {
                        var _b;
                        var data = _a.data, selected = _a.selected, expanded = _a.expanded;
                        return classNames((_b = {}, _b[styles.selectedRow] = selected, _b[styles.expandedRow] = expanded, _b));
                    }, cellStyles: function (_a) {
                        var _b;
                        var data = _a.data, selected = _a.selected, expanded = _a.expanded;
                        return classNames((_b = {}, _b[styles.expandedRow] = expanded, _b));
                    }, rowExpansion: {
                        content: expansionContent,
                        expandedIds: expandedIds,
                        onExpand: function (row) {
                            var newMeds = produce(props.values.requestItems, function (draft) {
                                draft.forEach(function (it) {
                                    if (it.id === row.id) {
                                        it.showNotes = true;
                                        it.selected = true;
                                    }
                                });
                            });
                            props.setFieldValue('requestItems', newMeds);
                        },
                        columnWidth: 120,
                        toggleCell: toggleCell,
                        cellStyles: function (_a) {
                            var _b;
                            var data = _a.data;
                            var expiryStatus = expiryStatusFromDate(data.patientMedication.expiresOn);
                            var isInactive = isInactiveMedicationStatus(data.patientMedication.status);
                            return classNames(styles.selectedRow, (_b = {},
                                _b[styles.rowExpired] = !isInactive && expiryStatus === MedicationExpiry.Expired,
                                _b[styles.rowAboutToExpire] = !isInactive && expiryStatus === MedicationExpiry.AboutToExpire,
                                _b));
                        }
                    }, columnExtensions: columnExtensions }))))))));
};
function FetchMedicationToRequest(props) {
    var _this = this;
    var medicationSettings = useMedicationSettings();
    var loadData = function () { return __awaiter(_this, void 0, void 0, function () {
        var newExpireDate, data, medications, pharmacyRequestExpiry, pharmacyRequestExpiry, newFormValues, e_2, e_3;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    props.onLoadStart();
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 10, , 11]);
                    newExpireDate = '';
                    return [4 /*yield*/, props.getMedicationsToRequest()];
                case 2:
                    data = _e.sent();
                    medications = data.medications.map(function (it) { return ({
                        id: uniqueId('med-request-'),
                        notes: it.existingRequestDetails.notes,
                        showNotes: !!it.existingRequestDetails.notes,
                        selected: true,
                        patientMedication: it
                    }); });
                    if (medicationSettings.settings.defaultPharmacyRequestLength != null &&
                        medicationSettings.settings.defaultPharmacyRequestLength.number >= 0) {
                        pharmacyRequestExpiry = moment().add(medicationSettings.settings.defaultPharmacyRequestLength.number, 'months').endOf('month');
                        newExpireDate = moment(pharmacyRequestExpiry).format(ValidDateFormats.IsoFormat);
                    }
                    else {
                        pharmacyRequestExpiry = moment().add(30, 'days');
                        newExpireDate = moment(pharmacyRequestExpiry).format(ValidDateFormats.IsoFormat);
                    }
                    newFormValues = __assign(__assign({}, props.values), { requestItems: medications, pickupLocation: (_a = data.defaultEncounterPlace) !== null && _a !== void 0 ? _a : null, expiresOn: newExpireDate !== null && newExpireDate !== void 0 ? newExpireDate : '' });
                    if (!props.headlessUpdate) return [3 /*break*/, 8];
                    _e.label = 3;
                case 3:
                    _e.trys.push([3, 6, , 7]);
                    return [4 /*yield*/, createPharmacyRequestSchema.validate(newFormValues)];
                case 4:
                    _e.sent();
                    return [4 /*yield*/, props.headlessUpdate.update(newFormValues)];
                case 5:
                    _e.sent();
                    return [3 /*break*/, 7];
                case 6:
                    e_2 = _e.sent();
                    console.error('Unable to validate Pharmacy Request: ', e_2);
                    props.headlessUpdate.onValidationFailure('Unable to pre-validate the form', e_2);
                    return [3 /*break*/, 7];
                case 7: return [3 /*break*/, 9];
                case 8:
                    props.resetForm({
                        values: newFormValues,
                        touched: {
                            pickupLocation: true,
                            expiresOn: true
                        }
                    });
                    props.validateForm();
                    props.onLoadFinished();
                    _e.label = 9;
                case 9: return [3 /*break*/, 11];
                case 10:
                    e_3 = _e.sent();
                    console.error('Unable to load data');
                    props.onError("Unable to load medication to create " + ((_d = (_c = (_b = medicationSettings.settings.pharmacyRequestTerm) === null || _b === void 0 ? void 0 : _b.abbreviatedSingularTerm) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : 'request'));
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadData();
    }, []);
    return null;
}
